export const getters = {
  /** API **/
  getApiKey(state) {
    return state.apiKey;
  },

  /** Error **/
  getAuthRegisterError(state) {
    return state.registerError;
  },
  getAuthRegisterErrorText(state) {
    return state.registerErrorText;
  },

  /** Form **/
  getFormData(state) {
    return state.formData;
  },

  /** Loading spinner **/
  isPageLoading(state) {
    return state.isLoading;
  },
}
